export default "__VITE_ASSET__B8BOJJ24__ 285w";